import { render, staticRenderFns } from "./UploadFiles.vue?vue&type=template&id=62d37e70&scoped=true&lang=pug&"
import script from "./UploadFiles.vue?vue&type=script&lang=js&"
export * from "./UploadFiles.vue?vue&type=script&lang=js&"
import style0 from "./UploadFiles.vue?vue&type=style&index=0&id=62d37e70&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62d37e70",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src142773959/src/bsix_meet_client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('62d37e70')) {
      api.createRecord('62d37e70', component.options)
    } else {
      api.reload('62d37e70', component.options)
    }
    module.hot.accept("./UploadFiles.vue?vue&type=template&id=62d37e70&scoped=true&lang=pug&", function () {
      api.rerender('62d37e70', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/fv_atril_video/UploadFiles.vue"
export default component.exports